export default (input: string): string => {
  return input.split('\n').join('<br/>');
};
